import(/* webpackMode: "eager" */ "/workspace/web-admin/app/(auth)/register/page.tsx");
